import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ControleSeapService } from '../controle-seap.service';

@Component({
  selector: 'app-add-curso',
  templateUrl: './add-curso.component.html',
  styleUrls: ['./add-curso.component.scss']
})
export class AddCursoComponent implements OnInit {
  name;
  time;
  id;

  constructor(private toastr: ToastrService, private server: ControleSeapService, private router: Router, private route: ActivatedRoute) { 
    if(this.route.snapshot.params['id']) {
      this.id = this.route.snapshot.params['id'];
      server.getCursoById(this.id).then(res => {
        if (res && res.val()) {
          this.name = res.val().name;
          this.time = res.val().time;
        } else{
          this.id = null;
        }
      }).catch(() =>
        this.id = null
      );
    }
  }

  ngOnInit() {
  }

  send() {
    if (!this.name || !this.name.toString().length){
      this.toastr.error('Você deve informar o nome do curso!');
      return;
    }
    
    if (!this.time || !this.time.toString().length || !Number(this.time)){
      this.toastr.error('Você deve informar o tempo de duração do curso em dias!');
      return;
    }

    this.time = Number(this.time);

    this.server.insertCurso({name: this.name, time: this.time}, this.id).then(res => {

      if (res) {
        this.toastr.success('Curso salvo!');
        this.router.navigate(['/controle-seap'])
        return;
      } else {
        this.toastr.error('Ocorreu um erro, tente novamente!')
      }
    })
  }

}
